/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1DepositAdvanceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_STATE_ENTITY_NAME = 'ixc.portfolio.v1.DepositAdvance';
export const ixcPortfolioV1DepositAdvanceStateEntity = new schema.Entity<IxcPortfolioV1DepositAdvanceState>(IXC_PORTFOLIO_V1_DEPOSIT_ADVANCE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1DepositAdvanceState) => `${entity.accountId}-${entity.fundingId}` });

